import styled from 'styled-components';
import type { ReactNode } from 'react';

import { Link } from 'components/Toolkit/Button/Link';

export interface IStatusBar {
  status: ReactNode | string;
  linkText: string | ReactNode;
  handleClick?: (string: any) => void;
  href?: string;
  className?: string;
}

const Container = styled.div`
  ${({ theme }) => theme.fontSize.M14}
  display: flex;
  background-color: ${({ theme }) => theme.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.S8};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  justify-content: space-between;
  border-radius: ${({ theme }) =>
    `${theme.borderRadius.default} ${theme.borderRadius.default} 0 0`};
`;

const StatusText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

function StatusBar({
  status,
  linkText,
  href,
  handleClick,
  className,
}: IStatusBar) {
  return (
    <Container className={className}>
      <StatusText>{status}</StatusText>
      {linkText && !href ? (
        <Link ofType="SECONDARY" onClick={handleClick} isFakeLink>
          {linkText}
        </Link>
      ) : (
        <Link ofType="SECONDARY" href={href}>
          {linkText}
        </Link>
      )}
    </Container>
  );
}

export { StatusBar };
